import { noop } from "@common/helpers/function";
import { createContext, useContext } from "react";
import { ClientDetailsRow } from "./views/clientViewConfig";

interface ClientActionsContextType {
    addEntityToClient(workspaceId: string): void;
    editClient(client: ClientDetailsRow): void;
    transferBillingToClient(client: ClientDetailsRow): void;
    requestBillingTransferFromClient(client: ClientDetailsRow): void;
    removeClient(client: ClientDetailsRow): void;
    transferBillingAndRemoveClient(client: ClientDetailsRow): void;
    deleteClient(client: ClientDetailsRow): void;
}

export const ClientActionsContext = createContext<ClientActionsContextType>({
    addEntityToClient: noop,
    editClient: noop,
    transferBillingToClient: noop,
    requestBillingTransferFromClient: noop,
    removeClient: noop,
    transferBillingAndRemoveClient: noop,
    deleteClient: noop,
});

export function useClientActions() {
    return useContext(ClientActionsContext);
}
